/* App Slider — "tabs" layout (sections/app-slider.liquid, layout: tabs).
   Vanilla JS, scoped per section element so several instances can coexist. */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 798px)';

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function initAppTabs(root) {
    if (!root || root.appTabsReady) return;
    root.appTabsReady = true;

    var tabs = toArray(root.querySelectorAll('[data-app-tab]'));
    var panels = toArray(root.querySelectorAll('[data-app-panel]'));
    var media = toArray(root.querySelectorAll('[data-app-media]'));
    var dots = toArray(root.querySelectorAll('[data-app-dot]'));
    var scroller = root.querySelector('[data-app-panels]');
    var toggle = root.querySelector('[data-app-toggle]');
    if (tabs.length < 1 || !scroller) return;

    var mobile = window.matchMedia(MOBILE_QUERY);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var index = 0;
    var scrollLock = null;
    var scrollLockTimer = null;
    var scrollRaf = null;

    function panelOffset(i) {
      return panels[i].offsetLeft - panels[0].offsetLeft;
    }

    function scrollToPanel(i, instant) {
      if (!mobile.matches || !panels[i]) return;
      scrollLock = i;
      clearTimeout(scrollLockTimer);
      scrollLockTimer = setTimeout(function () { scrollLock = null; }, 900);
      var left = panelOffset(i);
      var smooth = !instant && !reducedMotion.matches;
      if (typeof scroller.scrollTo === 'function') {
        scroller.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
      } else {
        scroller.scrollLeft = left;
      }
    }

    function select(i, options) {
      options = options || {};
      var count = tabs.length;
      i = ((i % count) + count) % count;
      index = i;
      tabs.forEach(function (tab, n) {
        var active = n === i;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (panel, n) { panel.classList.toggle('is-active', n === i); });
      media.forEach(function (item, n) { item.classList.toggle('is-active', n === i); });
      dots.forEach(function (dot, n) {
        var active = n === i;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (options.scroll !== false) scrollToPanel(i, options.instant);
      if (options.focus && tabs[i]) tabs[i].focus({ preventScroll: true });
    }

    /* ---- autoplay ---- */
    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true' && tabs.length > 1;
    var speed = Math.max(2, parseFloat(root.getAttribute('data-autoplay-speed')) || 6) * 1000;
    var timer = null;
    var userPaused = false;
    var hovering = false;
    var focused = false;
    var inView = false;

    function canPlay() {
      return autoplayEnabled && !userPaused && !hovering && !focused && inView &&
        !reducedMotion.matches && !document.hidden;
    }

    function updateToggle() {
      if (!toggle) return;
      toggle.hidden = !autoplayEnabled || reducedMotion.matches;
      toggle.classList.toggle('is-paused', userPaused);
      toggle.setAttribute('aria-label', toggle.getAttribute(userPaused ? 'data-label-play' : 'data-label-pause'));
    }

    function schedule() {
      clearTimeout(timer);
      timer = null;
      if (!canPlay()) return;
      timer = setTimeout(function () {
        timer = null;
        if (canPlay()) select(index + 1);
        schedule();
      }, speed);
    }

    function stopForUser() {
      if (!autoplayEnabled || userPaused) return;
      userPaused = true;
      updateToggle();
      schedule();
    }

    /* ---- events ---- */
    tabs.forEach(function (tab, n) {
      tab.addEventListener('click', function () {
        stopForUser();
        select(n);
      });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        switch (event.key) {
          case 'ArrowDown':
          case 'ArrowRight': next = n + 1; break;
          case 'ArrowUp':
          case 'ArrowLeft': next = n - 1; break;
          case 'Home': next = 0; break;
          case 'End': next = tabs.length - 1; break;
          default: return;
        }
        event.preventDefault();
        stopForUser();
        select(next, { focus: true });
      });
    });

    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () {
        stopForUser();
        select(n);
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        updateToggle();
        schedule();
      });
    }

    ['touchstart', 'pointerdown', 'wheel'].forEach(function (type) {
      scroller.addEventListener(type, function () {
        scrollLock = null;
        if (mobile.matches) stopForUser();
      }, { passive: true });
    });

    scroller.addEventListener('scroll', function () {
      if (!mobile.matches || scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(function () {
        scrollRaf = null;
        var position = scroller.scrollLeft;
        var nearest = 0;
        var best = Infinity;
        panels.forEach(function (panel, n) {
          var distance = Math.abs(panelOffset(n) - position);
          if (distance < best) { best = distance; nearest = n; }
        });
        if (scrollLock !== null) {
          if (nearest === scrollLock && best < 2) scrollLock = null;
          return;
        }
        if (nearest !== index) select(nearest, { scroll: false });
      });
    }, { passive: true });

    root.addEventListener('mouseenter', function () { hovering = true; schedule(); });
    root.addEventListener('mouseleave', function () { hovering = false; schedule(); });
    root.addEventListener('focusin', function () { focused = true; schedule(); });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) { focused = false; schedule(); }
    });
    document.addEventListener('visibilitychange', schedule);

    function onMediaChange() {
      if (mobile.matches) scrollToPanel(index, true);
      else scroller.scrollLeft = 0;
      updateToggle();
      schedule();
    }
    /* 600px: below it the tab content is a swipe carousel, above it a crossfade stack */
    [mobile, reducedMotion, window.matchMedia('(max-width: 599px)')].forEach(function (query) {
      if (query.addEventListener) query.addEventListener('change', onMediaChange);
      else if (query.addListener) query.addListener(onMediaChange);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0.35 }).observe(root);
    } else {
      inView = true;
    }

    /* theme editor: selecting a block shows its tab */
    root.addEventListener('shopify:block:select', function (event) {
      var n = tabs.indexOf(event.target);
      if (n > -1) {
        stopForUser();
        select(n, { instant: true });
      }
    });

    tabs.forEach(function (tab, n) {
      if (tab.getAttribute('aria-selected') === 'true') index = n;
    });
    if (index > 0 && mobile.matches) scrollToPanel(index, true);

    updateToggle();
    schedule();
  }

  function initAll(scope) {
    toArray((scope || document).querySelectorAll('[data-app-tabs]')).forEach(initAppTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
